import React from 'react';
import { IconProps } from '../IconProps';


export const MatchDeviceDisplayIcon: React.FC<IconProps> = ({
	width = 224,
	height = 150,
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 224 150"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g>
			<mask id="path-1-inside-1_7356_145940" fill="white">
				<path d="M32 31C32 22.1634 39.1634 15 48 15H176C184.837 15 192 22.1634 192 31V123C192 131.837 184.837 139 176 139H48C39.1634 139 32 131.837 32 123V31Z" />
			</mask>
			<path
				d="M32 31C32 22.1634 39.1634 15 48 15H176C184.837 15 192 22.1634 192 31V123C192 131.837 184.837 139 176 139H48C39.1634 139 32 131.837 32 123V31Z"
				fill="white"
			/>
			<path
				d="M48 15V16H176V15V14H48V15ZM192 31H191V123H192H193V31H192ZM176 139V138H48V139V140H176V139ZM32 123H33V31H32H31V123H32ZM48 139V138C39.7157 138 33 131.284 33 123H32H31C31 132.389 38.6112 140 48 140V139ZM192 123H191C191 131.284 184.284 138 176 138V139V140C185.389 140 193 132.389 193 123H192ZM176 15V16C184.284 16 191 22.7157 191 31H192H193C193 21.6112 185.389 14 176 14V15ZM48 15V14C38.6112 14 31 21.6112 31 31H32H33C33 22.7157 39.7157 16 48 16V15Z"
				fill="#D9D9D9"
				mask="url(#path-1-inside-1_7356_145940)"
			/>
			<g opacity="0.8" filter="url(#filter1_f_7356_145940)">
				<rect x="40.0557" y="57" width="48" height="40" rx="2" fill="#BDF0ED" />
				<path
					d="M56.5 75.4721L59.9261 66.1793H60.8148V67.6798H60.4477L57.7172 75.4721H56.5ZM58.0521 72.8124L58.4127 71.8271H62.6115L62.9722 72.8124H58.0521ZM63.2813 75.4721L60.5508 67.6798V66.1793H61.0724L64.4984 75.4721H63.2813ZM67.5454 75.5945C67.1075 75.5945 66.7125 75.5107 66.3605 75.3433C66.0127 75.1759 65.7358 74.9376 65.5297 74.6285C65.3279 74.3194 65.227 73.9544 65.227 73.5337V73.5208C65.227 73.1086 65.3258 72.7566 65.5233 72.4646C65.7208 72.1684 66.0084 71.9366 66.3862 71.7691C66.764 71.6017 67.2213 71.5029 67.7579 71.4729L70.3082 71.3183V72.2135L67.8932 72.368C67.3651 72.3981 66.9787 72.5076 66.734 72.6965C66.4936 72.8854 66.3733 73.1516 66.3733 73.495V73.5079C66.3733 73.86 66.5064 74.1347 66.7726 74.3322C67.0388 74.5254 67.3737 74.622 67.7773 74.622C68.1594 74.622 68.4985 74.5469 68.7948 74.3966C69.091 74.2421 69.3228 74.0339 69.4903 73.772C69.662 73.5101 69.7479 73.2138 69.7479 72.8832V70.7194C69.7479 70.2901 69.6169 69.9638 69.355 69.7405C69.0974 69.513 68.7089 69.3992 68.1894 69.3992C67.773 69.3992 67.4316 69.4744 67.1655 69.6246C66.8993 69.7706 66.7211 69.9788 66.6309 70.2493L66.6245 70.2686H65.5039L65.5104 70.23C65.5705 69.8651 65.7208 69.5473 65.9612 69.2769C66.2059 69.0021 66.5215 68.7896 66.9079 68.6393C67.2943 68.4848 67.7343 68.4075 68.228 68.4075C68.7948 68.4075 69.2735 68.4998 69.6642 68.6844C70.0591 68.869 70.3575 69.1352 70.5593 69.4829C70.7654 69.8264 70.8684 70.2386 70.8684 70.7194V75.4721H69.7479V74.4482H69.6448C69.4989 74.6929 69.3207 74.9011 69.1103 75.0728C68.9042 75.2446 68.6703 75.3755 68.4084 75.4657C68.1465 75.5515 67.8588 75.5945 67.5454 75.5945Z"
					fill="black"
				/>
				<path
					d="M63.6467 81.3449C63.8707 80.957 64.4305 80.957 64.6544 81.3449L66.5993 84.7136C66.8233 85.1015 66.5434 85.5863 66.0955 85.5863H62.2057C61.7578 85.5863 61.4779 85.1015 61.7018 84.7136L63.6467 81.3449Z"
					fill="#007AFF"
				/>
				<circle cx="66.9779" cy="89.3363" r="2.19174" fill="#007AFF" />
				<rect
					x="58.9414"
					y="86.8991"
					width="4.627"
					height="4.627"
					rx="0.581783"
					fill="#007AFF"
				/>
			</g>
			<path
				d="M105.975 81.775L110.726 77.002L105.975 72.2291"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M110.725 76.9993H98.056"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M127.695 60.8906C127.695 59.7861 128.591 58.8906 129.695 58.8906H175.695C176.8 58.8906 177.695 59.7861 177.695 60.8906V91.8906C177.695 92.9952 176.8 93.8906 175.695 93.8906H129.695C128.591 93.8906 127.695 92.9952 127.695 91.8906V60.8906Z"
				fill="#BDF0ED"
			/>
			<path
				d="M125.695 91.8906V60.8906C125.695 58.6815 127.486 56.8906 129.695 56.8906V58.8906L129.491 58.9014C128.483 59.0036 127.695 59.855 127.695 60.8906V91.8906L127.706 92.0947C127.808 93.1034 128.66 93.8906 129.695 93.8906H175.695C176.8 93.8906 177.695 92.9952 177.695 91.8906V60.8906C177.695 59.855 176.908 59.0036 175.899 58.9014L175.695 58.8906V56.8906C177.904 56.8906 179.695 58.6815 179.695 60.8906V91.8906C179.695 94.0998 177.904 95.8906 175.695 95.8906H129.695C127.486 95.8906 125.695 94.0998 125.695 91.8906ZM175.695 56.8906V58.8906H129.695V56.8906H175.695Z"
				fill="#171717"
			/>
			<path
				d="M145.14 73.8594L148.566 64.5665H149.454V66.067H149.087L146.357 73.8594H145.14ZM146.692 71.1997L147.052 70.2144H151.251L151.612 71.1997H146.692ZM151.921 73.8594L149.19 66.067V64.5665H149.712L153.138 73.8594H151.921ZM156.185 73.9817C155.747 73.9817 155.352 73.898 155 73.7306C154.652 73.5631 154.375 73.3249 154.169 73.0157C153.968 72.7066 153.867 72.3417 153.867 71.9209V71.9081C153.867 71.4959 153.965 71.1439 154.163 70.8519C154.36 70.5557 154.648 70.3238 155.026 70.1564C155.404 69.989 155.861 69.8902 156.398 69.8602L158.948 69.7056V70.6008L156.533 70.7553C156.005 70.7854 155.618 70.8948 155.374 71.0838C155.133 71.2727 155.013 71.5388 155.013 71.8823V71.8952C155.013 72.2472 155.146 72.522 155.412 72.7195C155.678 72.9127 156.013 73.0093 156.417 73.0093C156.799 73.0093 157.138 72.9342 157.434 72.7839C157.731 72.6293 157.962 72.4211 158.13 72.1592C158.302 71.8973 158.388 71.6011 158.388 71.2705V69.1067C158.388 68.6774 158.257 68.3511 157.995 68.1278C157.737 67.9003 157.349 67.7865 156.829 67.7865C156.413 67.7865 156.071 67.8616 155.805 68.0119C155.539 68.1579 155.361 68.3661 155.271 68.6366L155.264 68.6559H154.144L154.15 68.6173C154.21 68.2523 154.36 67.9346 154.601 67.6641C154.846 67.3894 155.161 67.1768 155.548 67.0266C155.934 66.872 156.374 66.7947 156.868 66.7947C157.434 66.7947 157.913 66.8871 158.304 67.0717C158.699 67.2563 158.997 67.5225 159.199 67.8702C159.405 68.2137 159.508 68.6258 159.508 69.1067V73.8594H158.388V72.8354H158.284C158.139 73.0801 157.96 73.2884 157.75 73.4601C157.544 73.6318 157.31 73.7628 157.048 73.8529C156.786 73.9388 156.498 73.9817 156.185 73.9817Z"
				fill="black"
			/>
			<path
				d="M152.376 79.5965C152.599 79.2073 153.161 79.2073 153.384 79.5965L155.318 82.9611C155.541 83.349 155.261 83.8328 154.814 83.8328H150.946C150.499 83.8328 150.219 83.349 150.442 82.9611L152.376 79.5965Z"
				fill="#007AFF"
			/>
			<ellipse cx="155.694" cy="87.5824" rx="2.18164" ry="2.19174" fill="#007AFF" />
			<rect
				x="147.695"
				y="85.1484"
				width="4.60568"
				height="4.627"
				rx="0.581783"
				fill="#007AFF"
			/>
			<path
				d="M182.695 94.6094C183.386 94.6094 183.945 95.169 183.945 95.8594C183.945 96.5497 183.386 97.1094 182.695 97.1094H121.977C121.286 97.1094 120.727 96.5497 120.727 95.8594C120.727 95.169 121.286 94.6094 121.977 94.6094H182.695Z"
				fill="#171717"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_7356_145940"
				x="0"
				y="0"
				width="224"
				height="188"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="17" />
				<feGaussianBlur stdDeviation="16" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_7356_145940"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_7356_145940"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_f_7356_145940"
				x="39.0557"
				y="56"
				width="50"
				height="42"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="BackgroundImageFix"
					result="shape"
				/>
				<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_7356_145940" />
			</filter>
		</defs>
	</svg>
);

export const ScaleHighResolutionIcon: React.FC<IconProps> = ({
	width = 224,
	height = 150,
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 224 150"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g>
			<mask id="path-1-inside-1_7356_145946" fill="white">
				<path d="M32 31C32 22.1634 39.1634 15 48 15H176C184.837 15 192 22.1634 192 31V123C192 131.837 184.837 139 176 139H48C39.1634 139 32 131.837 32 123V31Z" />
			</mask>
			<path
				d="M32 31C32 22.1634 39.1634 15 48 15H176C184.837 15 192 22.1634 192 31V123C192 131.837 184.837 139 176 139H48C39.1634 139 32 131.837 32 123V31Z"
				fill="white"
			/>
			<path
				d="M48 15V16H176V15V14H48V15ZM192 31H191V123H192H193V31H192ZM176 139V138H48V139V140H176V139ZM32 123H33V31H32H31V123H32ZM48 139V138C39.7157 138 33 131.284 33 123H32H31C31 132.389 38.6112 140 48 140V139ZM192 123H191C191 131.284 184.284 138 176 138V139V140C185.389 140 193 132.389 193 123H192ZM176 15V16C184.284 16 191 22.7157 191 31H192H193C193 21.6112 185.389 14 176 14V15ZM48 15V14C38.6112 14 31 21.6112 31 31H32H33C33 22.7157 39.7157 16 48 16V15Z"
				fill="#D9D9D9"
				mask="url(#path-1-inside-1_7356_145946)"
			/>
			<g opacity="0.8">
				<rect x="40" y="57" width="38" height="40" rx="2" fill="#BDF0ED" />
				<path
					d="M51.4444 75.4721L54.8704 66.1793H55.7591V67.6798H55.392L52.6615 75.4721H51.4444ZM52.9964 72.8124L53.357 71.8271H57.5559L57.9165 72.8124H52.9964ZM58.2256 75.4721L55.4951 67.6798V66.1793H56.0167L59.4428 75.4721H58.2256ZM62.4898 75.5945C62.0518 75.5945 61.6568 75.5107 61.3048 75.3433C60.957 75.1759 60.6801 74.9376 60.474 74.6285C60.2723 74.3194 60.1714 73.9544 60.1714 73.5337V73.5208C60.1714 73.1086 60.2701 72.7566 60.4676 72.4646C60.6651 72.1684 60.9527 71.9366 61.3306 71.7691C61.7084 71.6017 62.1656 71.5029 62.7023 71.4729L65.2525 71.3183V72.2135L62.8375 72.368C62.3094 72.3981 61.923 72.5076 61.6783 72.6965C61.4379 72.8854 61.3177 73.1516 61.3177 73.495V73.5079C61.3177 73.86 61.4508 74.1347 61.717 74.3322C61.9831 74.5254 62.318 74.622 62.7216 74.622C63.1037 74.622 63.4429 74.5469 63.7391 74.3966C64.0353 74.2421 64.2672 74.0339 64.4346 73.772C64.6063 73.5101 64.6922 73.2138 64.6922 72.8832V70.7194C64.6922 70.2901 64.5613 69.9638 64.2994 69.7405C64.0418 69.513 63.6532 69.3992 63.1337 69.3992C62.7173 69.3992 62.376 69.4744 62.1098 69.6246C61.8436 69.7706 61.6654 69.9788 61.5753 70.2493L61.5688 70.2686H60.4483L60.4547 70.23C60.5148 69.8651 60.6651 69.5473 60.9055 69.2769C61.1502 69.0021 61.4658 68.7896 61.8522 68.6393C62.2386 68.4848 62.6787 68.4075 63.1724 68.4075C63.7391 68.4075 64.2178 68.4998 64.6085 68.6844C65.0035 68.869 65.3019 69.1352 65.5036 69.4829C65.7097 69.8264 65.8128 70.2386 65.8128 70.7194V75.4721H64.6922V74.4482H64.5892C64.4432 74.6929 64.265 74.9011 64.0547 75.0728C63.8486 75.2446 63.6146 75.3755 63.3527 75.4657C63.0908 75.5515 62.8032 75.5945 62.4898 75.5945Z"
					fill="black"
				/>
				<path
					d="M58.5911 81.3449C58.815 80.957 59.3748 80.957 59.5988 81.3449L61.5437 84.7136C61.7676 85.1015 61.4877 85.5863 61.0398 85.5863H57.15C56.7021 85.5863 56.4222 85.1015 56.6462 84.7136L58.5911 81.3449Z"
					fill="#007AFF"
				/>
				<circle cx="61.9222" cy="89.3363" r="2.19174" fill="#007AFF" />
				<rect
					x="53.8857"
					y="86.8991"
					width="4.627"
					height="4.627"
					rx="0.581783"
					fill="#007AFF"
				/>
			</g>
			<path
				d="M101.289 62.75V56H94.5391"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M101.289 56L92.2891 65"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M92.2891 89L101.289 98"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M94.2891 98L101.039 98L101.039 91.25"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<g opacity="0.8" filter="url(#filter1_f_7356_145946)">
				<rect x="115.6" y="41" width="68.4" height="72" rx="3.6" fill="#BDF0ED" />
				<path
					d="M136.706 73.2498L142.919 56.5226H144.472V59.0728H143.904L138.896 73.2498H136.706ZM139.546 68.4623L140.229 66.6887H147.671L148.355 68.4623H139.546ZM148.993 73.2498L143.985 59.0728V56.5226H144.982L151.184 73.2498H148.993ZM155.984 73.4816C155.188 73.4816 154.485 73.3309 153.875 73.0295C153.272 72.7281 152.797 72.3031 152.449 71.7544C152.109 71.198 151.939 70.5527 151.939 69.8185V69.7954C151.939 69.0998 152.113 68.4971 152.461 67.987C152.808 67.477 153.311 67.0751 153.967 66.7815C154.624 66.4878 155.416 66.3139 156.344 66.2598L160.841 66.0048V67.5697L156.587 67.8363C155.745 67.8827 155.103 68.0759 154.663 68.4159C154.222 68.756 154.002 69.2158 154.002 69.7954V69.8185C154.002 70.4059 154.222 70.8734 154.663 71.2212C155.111 71.5612 155.699 71.7312 156.425 71.7312C157.074 71.7312 157.654 71.596 158.164 71.3255C158.674 71.055 159.079 70.6879 159.381 70.2243C159.682 69.7606 159.833 69.2351 159.833 68.6478V65.0195C159.833 64.2776 159.601 63.698 159.137 63.2807C158.674 62.8634 158.013 62.6547 157.155 62.6547C156.382 62.6547 155.756 62.817 155.277 63.1416C154.806 63.4584 154.508 63.8796 154.385 64.4051L154.362 64.4979H152.403L152.414 64.3819C152.484 63.7173 152.719 63.1223 153.121 62.5968C153.523 62.0636 154.068 61.6424 154.756 61.3333C155.443 61.0241 156.255 60.8696 157.19 60.8696C158.156 60.8696 158.987 61.0319 159.682 61.3564C160.378 61.681 160.911 62.1447 161.282 62.7475C161.661 63.3425 161.85 64.0496 161.85 64.8688V73.2498H159.833V71.3139H159.752C159.512 71.7544 159.199 72.1369 158.813 72.4615C158.434 72.7861 158.005 73.0372 157.526 73.215C157.047 73.3927 156.533 73.4816 155.984 73.4816Z"
					fill="black"
				/>
				<path
					d="M149.063 84.4207C149.466 83.7226 150.474 83.7226 150.877 84.4207L154.378 90.4844C154.781 91.1825 154.277 92.0552 153.471 92.0552H146.469C145.663 92.0552 145.159 91.1825 145.562 90.4844L149.063 84.4207Z"
					fill="#007AFF"
				/>
				<circle cx="155.059" cy="98.8053" r="3.94513" fill="#007AFF" />
				<rect
					x="140.594"
					y="94.4185"
					width="8.3286"
					height="8.3286"
					rx="1.04721"
					fill="#007AFF"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_d_7356_145946"
				x="0"
				y="0"
				width="224"
				height="188"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="17" />
				<feGaussianBlur stdDeviation="16" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_7356_145946"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_7356_145946"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_f_7356_145946"
				x="114.475"
				y="39.875"
				width="70.6504"
				height="74.25"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="BackgroundImageFix"
					result="shape"
				/>
				<feGaussianBlur
					stdDeviation="0.5625"
					result="effect1_foregroundBlur_7356_145946"
				/>
			</filter>
		</defs>
	</svg>
);

export const OSScaleResolutionIcon: React.FC<IconProps> = ({
	width = 224,
	height = 150,
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 224 150"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g>
			<mask id="path-1-inside-1_7356_145774" fill="white">
				<path d="M32 31C32 22.1634 39.1634 15 48 15H176C184.837 15 192 22.1634 192 31V123C192 131.837 184.837 139 176 139H48C39.1634 139 32 131.837 32 123V31Z" />
			</mask>
			<path
				d="M32 31C32 22.1634 39.1634 15 48 15H176C184.837 15 192 22.1634 192 31V123C192 131.837 184.837 139 176 139H48C39.1634 139 32 131.837 32 123V31Z"
				fill="white"
			/>
			<path
				d="M48 15V16H176V15V14H48V15ZM192 31H191V123H192H193V31H192ZM176 139V138H48V139V140H176V139ZM32 123H33V31H32H31V123H32ZM48 139V138C39.7157 138 33 131.284 33 123H32H31C31 132.389 38.6112 140 48 140V139ZM192 123H191C191 131.284 184.284 138 176 138V139V140C185.389 140 193 132.389 193 123H192ZM176 15V16C184.284 16 191 22.7157 191 31H192H193C193 21.6112 185.389 14 176 14V15ZM48 15V14C38.6112 14 31 21.6112 31 31H32H33C33 22.7157 39.7157 16 48 16V15Z"
				fill="#D9D9D9"
				mask="url(#path-1-inside-1_7356_145774)"
			/>
			<g opacity="0.8" filter="url(#filter1_f_7356_145774)">
				<rect x="79.5" y="45" width="65" height="64" rx="3.2" fill="#BDF0ED" />
				<path
					d="M100.036 74.0553L105.538 59.1867H106.939V61.5154H106.393L101.983 74.0553H100.036ZM102.54 69.7998L103.127 68.2233H109.794L110.391 69.7998H102.54ZM110.917 74.0553L106.507 61.5154V59.1867H107.372L112.864 74.0553H110.917ZM117.451 74.2511C116.743 74.2511 116.115 74.1171 115.565 73.8492C115.016 73.5813 114.583 73.2035 114.267 72.7158C113.951 72.2212 113.793 71.6442 113.793 70.9847V70.9641C113.793 70.3253 113.948 69.7757 114.257 69.3155C114.573 68.8484 115.026 68.4843 115.617 68.2233C116.214 67.9554 116.936 67.7974 117.781 67.7493L121.82 67.5123V68.9239L117.997 69.1712C117.2 69.2125 116.606 69.3842 116.214 69.6864C115.823 69.9887 115.627 70.4043 115.627 70.9332V70.9538C115.627 71.5034 115.833 71.9327 116.245 72.2418C116.657 72.5441 117.186 72.6952 117.832 72.6952C118.423 72.6952 118.948 72.575 119.409 72.3345C119.876 72.0941 120.243 71.7678 120.511 71.3557C120.786 70.9366 120.923 70.4661 120.923 69.944V66.5953C120.923 65.9221 120.714 65.4034 120.295 65.0394C119.883 64.6753 119.278 64.4933 118.481 64.4933C117.808 64.4933 117.258 64.6238 116.833 64.8848C116.407 65.1458 116.132 65.503 116.008 65.9564L115.988 66.0079H114.226L114.236 65.9255C114.312 65.3416 114.535 64.823 114.906 64.3696C115.284 63.9094 115.778 63.5522 116.39 63.298C117.008 63.037 117.722 62.9064 118.533 62.9064C119.412 62.9064 120.161 63.0541 120.779 63.3495C121.404 63.638 121.882 64.0536 122.211 64.5963C122.548 65.139 122.716 65.7847 122.716 66.5334V74.0553H120.923V72.3758H120.8C120.58 72.7673 120.302 73.1039 119.965 73.3855C119.628 73.6672 119.247 73.8836 118.821 74.0347C118.402 74.1789 117.945 74.2511 117.451 74.2511Z"
					fill="black"
				/>
				<path
					d="M111.345 83.6514C111.703 83.0308 112.599 83.0308 112.957 83.6514L116.069 89.0413C116.428 89.6619 115.98 90.4376 115.263 90.4376H109.039C108.323 90.4376 107.875 89.6619 108.233 89.0413L111.345 83.6514Z"
					fill="#007AFF"
				/>
				<circle cx="116.676" cy="96.4377" r="3.50678" fill="#007AFF" />
				<rect
					x="103.817"
					y="92.5387"
					width="7.4032"
					height="7.4032"
					rx="0.930853"
					fill="#007AFF"
				/>
			</g>
			<path
				d="M166.793 42.75V36H160.043"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M166.793 36L157.793 45"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M157.793 111L166.793 120"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M159.793 120L166.543 120L166.543 113.25"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M55.917 42.75V36H62.667"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M55.917 36L64.917 45"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M64.917 111L55.917 120"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M62.917 120L56.167 120L56.167 113.25"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_7356_145774"
				x="0"
				y="0"
				width="224"
				height="188"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="17" />
				<feGaussianBlur stdDeviation="16" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_7356_145774"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_7356_145774"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_f_7356_145774"
				x="78.5"
				y="44"
				width="67"
				height="66"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="BackgroundImageFix"
					result="shape"
				/>
				<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_7356_145774" />
			</filter>
		</defs>
	</svg>
);
